const zh_CN = {
    site_title: "SuperMap iManager for Kubernetes 在线帮助",
    site_productName: "SuperMap iManager for Kubernetes",
    home_productName: "SuperMap iManager for Kubernetes",
    home_productDescrp: "云原生GIS解决方案",
    home_gettingStarted: "快速入门",
    //home_tutorial: "教程",
    header_home: "主页",
    header_tutorial:"教程",
    header_guides: "入门",
    header_microservices: "GIS云套件",
    header_docs: "文档",
    header_topics: "技术专题",
    header_terms: "GIS 术语",
    header_api: "开发文档",
    header_blog: "博客",
    header_community: "社区",
    footer_guides: "入门",
    footer_tutorial:"教程",
    footer_microservices:"GIS云套件",
    footer_docs: "文档",
    footer_topics: "技术专题",
    footer_api: "开发文档",
    footer_specs:"文档规范",
    rightcontents_title:"本页内容",
    //... ...
}
export default zh_CN;